import axios from 'axios'
import {Message} from 'element-ui'
import router, {resetRouter} from "@/router";
import {AUTHORIZATION, getTenant, getToken, getUserId} from "@/utils/auth";
import {Base64} from "js-base64";
import {RESPONSE_CODE} from "@/utils/const";
import store from '@/store'
import {USER_RESET_USER} from "@/store/action-types";
import qs from 'qs'
import {urlList} from './repeatRequestUrl';

let pendingRequests = [];   // 请求的 URL
let cancelToken = axios.CancelToken;

let removeRepeatUrl = (ever, type) => {
    // 如果返回的URL拼接了 baseURL 就干掉
    let str = (ever.url.startsWith(ever.baseURL) ? ever.url.replace(ever.baseURL, '') : ever.url) + '&' + ever.method;
    let index = pendingRequests.findIndex(p => p.u === str);
    if (index !== -1) {
        if (type === 'request') {
            pendingRequests[index].cancel('cancelToken'); // 执行取消操作
        }
        pendingRequests.splice(index, 1);
    }
}

// 判断是否 存在 重复 URL名单内
function checkIncludeUrl(url) {

    let strUrl = url.split('=')[0];
    let regUrl = strUrl.split('/');
    if (!isNaN(Number(regUrl[regUrl.length - 1]))) {   // 判断特殊情况 以 ${id}结尾的
        regUrl.pop()
        if (urlList.includes(regUrl.join('/') + '/${id}')) {
            return true;
        }
    }
  if (!isNaN(Number(regUrl[regUrl.length - 2]))) {   // 判断特殊情况 倒数第二个${id}结尾的  'crm/review/407372/matchOrderList'
    regUrl.splice(-2,1,'${id}');
    regUrl = regUrl.join('/');
    return urlList.includes(regUrl);
  }
    return urlList.includes(strUrl);
}

let baseURL;
if (process.env.NODE_ENV === 'production') {
  baseURL = `${window.location.protocol}//${window.location.hostname}/api`;
} else {
  baseURL = `${process.env.VUE_APP_BASE_URL}/api`;
}

// create an axios instance
const service = axios.create({
  baseURL,
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 1000 * 60 * 5 // request timeout
});

const whiteUrls = [
  '/oauth/anno/token',
  '/oauth/anno/innerToken',
  '/oauth/anno/registerCaptcha',
  '/oauth/anno/register',
  '/oauth/anno/getAuthInfo',
  '/oauth/anno/forgetPwdConfirm',
  '/oauth/informationRetrieval/anno/bdUpload',
];

// request interceptor
service.interceptors.request.use(config => {
    config.headers['Authorization'] = AUTHORIZATION;
    if (!whiteUrls.some(url => config.url.includes(url))) {
      // 区分公共下载的租户编码 默认为 0000
      if(config.url.indexOf('/file/attachment/download/biz') !== -1) {
        config.headers['tenant'] = 'MDAwMA==';
      } else {
        config.headers['tenant'] = Base64.encode(getTenant());
      }
      // if (config.url.indexOf('/ads/') !== -1) {
      //   config.headers['tenant'] = getTenant();
      // } else {
      //   config.headers['tenant'] = Base64.encode(getTenant());
      // }
      config.headers['token'] = `Bearer ${getToken()}`;
      config.headers['userId'] = getUserId();
    }

    if (config.method === 'get') {
      config.paramsSerializer = function(params) {
        return qs.stringify(params, { arrayFormat: 'repeat' })
      }
    }
      // 在白名单内的 才过滤 重复请求
      if (checkIncludeUrl(config.url)) {
        removeRepeatUrl(config, 'request');
        config.cancelToken = new cancelToken((c) => {
          // 请求时  存入 url 信息
          pendingRequests.push({u: config.url + '&' + config.method, cancel: c});
        });
      }
    return config;
  },
  error => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  async response => {
    // 状态码为200的响应数据
    if (response.status === 200) {
      const data = response.data;
      removeRepeatUrl(response.config, 'response');
      // 登录过期
      if ([40000, 40001, 40002, 40003, 40004, 40005, 40006, 40007, 40008].includes(data.code)) {
        if (!window.location.pathname.includes('/login')) {
          Message.closeAll();
          Message({
            message: data.code === 40008?'密码已变更，请重新登录':data.msg?data.msg:'登录过期，请重新登录',
            type: 'error',
            duration: 3 * 1000
          });
        }
        await store.dispatch(USER_RESET_USER);
        resetRouter();
        if (!window.location.pathname.includes('/login')) {
          router.push('/login');
        }
        pendingRequests = [];  // 异常情况下 清空 所有的请求
        throw new Error();
      }
      // 系统超时
      if (data.code === RESPONSE_CODE.TIMEOUT) {
        Message({
          message: data.msg,
          type: 'error',
          duration: 3 * 1000
        });
        pendingRequests = [];  // 异常情况下 清空 所有的请求
        throw new Error();
      }

      if (data.code < 0 && !data.data) {
        Message({
          message: data.msg,
          type: 'error',
          duration: 3 * 1000
        });
        pendingRequests = [];  // 异常情况下 清空 所有的请求
        throw new Error(data.msg);
      }

      if (data instanceof Blob) {
        return response;
      }

      return data;
    } else {
      let errMsg = '网络错误，请重试';
      if (response.data && response.data.msg) {
        errMsg = response.data.msg;
      }
      Message({
        message: errMsg,
        type: 'error',
        duration: 3 * 1000
      });
      pendingRequests = [];  // 异常情况下 清空 所有的请求
      throw new Error();
    }
  },
  error => {
    const response = error.response;
    Message.closeAll();
    if (!response || !response.data) {
      return Promise.reject(error)
    }
    // 请求超时拦截
    if(error.code === 'ECONNABORTED' || error.message === "Network Error" || error.message.includes("timeout")) {
      Message({
        message: '请求超时，请稍后重试',
        type: "error",
        duration: 3 * 1000,
      })
      return Promise.reject(error)
    }

    // 正常流程 /请求超时
    if (response.request.responseType !== 'blob') {
      Message({
        message: response.data.msg || response.msg || response.data.message || '网络错误，请重试',
        type: 'error',
        duration: 3 * 1000
      });
      return Promise.reject(error)
    }
    // 文件导出报错处理
    const fileReader = new FileReader()
    fileReader.onload = function() {
      let jsonData = JSON.parse(this.result);  // 说明是普通对象数据，后台转换失败
      Message({
        message: jsonData.msg || jsonData.message || '网络错误，请重试',
        type: 'error',
        duration: 3 * 1000
      });
      return Promise.reject(error)
    }
    fileReader.readAsText(response.data)
  }
);

export default service
